/* eslint-disable comma-dangle */
const english = {
  auth_login: 'Login',
  auth_logout: 'Logout',
  loading: 'Loading...',
  auth_insert_username: 'Insert your Username',
  auth_insert_password: 'Insert your  password',
  auth_enter_email: 'Insert your username to recover your password',
  auth_forgot_password: 'Did you forgot your password?',
  auth_continue_login: 'Continue to login',
  auth_password_match: 'Passwords do not match',
  auth_reset_password: 'Reset Password ',
  auth_confirm_password: 'Confirm password',
  common_email: 'Email',
  common_username: 'Username',
  common_password: 'Password',
  common_name: 'Name',
  common_last_name: 'Last name',
  common_insert_name: 'Insert name of the minor',
  common_back: 'Back',
  common_birthday: 'Birthday',
  common_birthplace: 'Birthplace',
  common_citizenship: 'Citizenship',
  common_insert_birthday: 'Insert birthday date',
  common_pin: 'PIN',
  common_insert_pin: 'Insert PIN',
  common_insert: 'Insert',
  common_continue: 'Continue',
  common_change_password: 'Change Password',
  common_province: 'Province',
  common_user_or_email: 'Username or Email',
  common_postal: 'Postal Code',
  common_notes: 'Special Notes',
  common_diseases: 'Diseases',
  common_city: 'City',
  common_street_number: 'Street number',
  common_street: 'Street',
  common_fraction: 'Fraction',
  common_resident: 'Resident',
  common_special: 'Special',
  common_special_info: 'Special Information',
  common_general: 'General',
  common_add_special: 'Add special entry for today',
  common_daily_validity: 'With daily validity. At the end of the day it resets',
  common_none: 'None',
  common_left: 'Leave',
  common_without_appeal: 'Without rollcall',
  common_with_alarm: 'With alarm',
  kids_calendar: 'Calendar Minor',
  kids_my_kids: 'My Kids',
  kids_other_kids: 'The other kids',
  kids: 'Kids',
  kids_list: 'Kids List',
  kids_other_features: 'Other features',
  kids_profile: 'Kid\'s Profile',
  kids_time: 'Time slot',
  kids_accompanied: 'In which the child will usually be accompanied',
  kids_accompanied_to: 'Today will arrive',
  kids_usually_accompanied: 'The child is usually accompanied',
  kids_allergies: 'Allergies/Intolerances',
  class: 'Class',
  class_on_hold: 'On hold',
  class_present: 'Present',
  class_teacher: 'Teacher',
  class_list: 'Class List',
  class_appeal: 'Rollcall',
  class_mensa: 'Mensa',
  class_absence: 'Absence',
  class_absence_reported: 'Absence reported by',
  class_absence_justified: 'JUSTIFIED ABSENCE SIGN',
  remove_class_absence_justified: 'REMOVE JUSTIFIED ABSENCE',
  profile_data: 'Personal data',
  profile_data_kid: 'Child registry',
  profile_fiscal_code: 'Fiscal Code',
  profile_username: 'Username',
  profile_insert_fiscal: 'Enter the tax code to associate a component',
  profile_associate: 'Associate',
  token_failed: 'Verification Failed, please try again or contact the customer care',
  profile_mobile: 'Mobile Contact',
  profile_phone: 'Phone contact',
  family: 'Family',
  family_relationship: 'Relationship',
  family_adm: 'Administrator',
  family_contacts: 'Family contacts',
  associate_error: 'Invalid data: check if username or email are valid',
  homepage: 'Homepage',
  parent: 'Parent',
  calendar: 'Calendar',
  error_wrong_credentials: 'Wrong credentials',
  error_user_not_found: 'User not found',
  emergency_phone: 'Emergency phone',
  kids_in_class: 'Kids in classroom',
  total: 'Total classroom',
  showReferences: 'Show my contacts',
  dontShowReferences: 'Dont show my contacts',
  areYouSureToConfirmAbsenceModal: 'Are you sure you want to mark justified absence?',
  areYouSureToRemoveAbsenceModal: 'Are you sure you want to remove justified absence from?',
  yes: 'Yes',
  no: 'No',
  generica: 'Generic',
  choose_language: 'Choose language:',
  english: 'English',
  italian: 'Italian',
  scanner_qr_code: 'Scanner QR Code',
  scan_qr_code_of: 'Scan QR Code of',
  to_mark_presence: 'to mark presence at school',
  something_went_wrong: 'something went wrong, try again to scan the QR Code!',
  scan: 'Scan',
  errorScanMessage: 'It was not possible to initialize scanning process due to permission reasons',
  well_done: 'Well done!',
  successfully_scanned_arrived: 'You have successfully scanned the presence in kindergarten!',
  successfully_scanned_left: 'You have successfully scanned the kindergarten exit!',
  ops: 'Ops',
  close_camera_to_qr_code: 'Move the camera close to the QrCode and wait for the scan result',
  present: 'present',
  absent: 'absent',
  uscita: 'exit',
  waiting_to_enter: 'waiting to enter',
  present_to_family: 'present for the family',
  on_hold: 'waiting for',
  attention: 'ATTENTION',
  exit: 'gone',
  closed_school: 'kindergarten closed',
  entered_at: 'entered at:',
  released_at: 'left at:',
  time_limit: 'time limit:',
  absent_justified: 'justified absent',
  time_limit_exceeded: 'time limit exceeded',
  language: 'Language',
  kids_number: 'Kids number',
  customer_care: 'Customer care',
  home: 'Home',
  edit_profile: 'Edit profile',
  chat_not_available: 'Chat not available',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  today: 'Today',
  login_failed: 'LOGIN FAILED - email or password is wrong',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  chat_class: 'Chat class',
  emergency_call_answered: 'Emergency call response',
  emergency_call_no_answer: 'Unanswered emergency call',
  emergency_call_forwarded: 'Emergency call attempt',
  presence_confirmed: 'Confirmed Presence',
  expected_absence_signaled: 'Report of absence of a justified person',
  arrival_time_exception: 'Extraordinary arrival time report',
  danger_status: 'State of danger',
  max_danger_status: 'State of maximum danger',
  qr_minor_arrived: 'Minor stamp delivered',
  qr_minor_left: 'Minor output stamp',
  arrival_time_exception_updated: 'Extraordinary arrival time changed',
  arrival_time_updated: 'Modified arrival time',
  minor_absence_teacher: 'Absence reported by teacher',
  no_tutor_answered: 'No response to calls',
  minor_left_class: 'Confirm exit from class',
  tutors_sms_sent: 'SMS sent to Tutors',
  admin: 'Admin',
  participants: 'No one | 1 participant | {count} participants',
  write_message: 'Write a message',
  and: 'and',
  register: 'Register',
  entry: 'entry',
  communication: 'Communication',
  chat: 'Chat',
  group_administrator: 'Group administrator',
  teacher: 'Teacher',
  unread_messages: '{count} unread message | {count} unread messages',
  inbox: 'Inbox',
  outbox: 'Outbox',
  new_message: 'New message',
  entry_message: 'Entry message',
  subject: 'Subject',
  search: 'Search',
  yesterday: 'Yesterday',
  this_weekend: 'This weekend',
  older: 'Older',
  no_result: 'No elements found.',
  send_to_all: 'Send to all',
  send_specific: 'Send to specific',
  minors: 'Minors',
  scheduled_absences: 'Scheduled Absences',
  scheduled: 'Scheduled',
  from: 'From',
  of: 'of',
  to: 'To',
  confirm_absence: 'Confirm absence',
  notValidTaxCode: 'Tax code not valid',
  userAlreadyAssociated: 'User already associated',
  userNotTutor: 'User is not a "Tutor"',
  generalError: 'General Error',
  done: 'Done',
  unexpectedError: 'An unexpected error occurred, please try again!',
  select: 'Select',
  selected: 'Selected',
  areYouSureToDeleteEmailModal: 'Are you sure you want to delete this email?'
};

export default english;
